import React, { useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Search, Database, FileText, LogOut, Shield } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import '../../components/Sidebar.css';
import '../../components/Layout.css';
import './Admin.css';

const NAV = [
  { name: 'Dashboard', href: '/admin', icon: LayoutDashboard },
  { name: 'Customers', href: '/admin/customers', icon: Users },
  { name: 'Search costs', href: '/admin/search', icon: Search },
  { name: 'Tables', href: '/admin/tables', icon: Database },
  { name: 'Audit log', href: '/admin/audit', icon: FileText },
];

function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className={`layout admin-area ${mobileOpen ? 'sidebar-open' : ''}`}>
      {mobileOpen && <div className="sidebar-backdrop" onClick={() => setMobileOpen(false)}></div>}
      <div className={`sidebar ${mobileOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            <Shield className="logo-icon" />
            <span className="logo-text">Admin</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-list">
            {NAV.map(({ name, href, icon: Icon }) => (
              <li key={name} className="nav-item">
                <Link
                  to={href}
                  className={`nav-link ${location.pathname === href ? 'active' : ''}`}
                  onClick={() => setMobileOpen(false)}
                >
                  <Icon className="nav-icon" />
                  <span className="nav-text">{name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              <Users className="avatar-icon" />
            </div>
            <div className="user-details">
              <div className="user-name">{user?.name || user?.email || 'Operator'}</div>
              <div className="user-role">{user?.email}</div>
            </div>
          </div>
          <button className="logout-button" onClick={handleLogout} title="Sign out" type="button">
            <LogOut className="logout-icon" />
            <span>Sign out</span>
          </button>
        </div>
      </div>

      <div className="main-content">
        <header className="top-header">
          <div className="header-container">
            <button
              className="mobile-menu-toggle"
              onClick={() => setMobileOpen((v) => !v)}
              aria-label="Toggle menu"
              type="button"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 12h18M3 6h18M3 18h18" />
              </svg>
            </button>
          </div>
        </header>
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
